<script setup lang="ts">
import { sendLoggedOutEvent } from '@/utils/mixpanel'

const showLogOutConfirmation = ref(false)

interface CustomWindow extends Window {
  webkit?: any
}

declare const window: CustomWindow

const handleLogOut = async () => {
  sendLoggedOutEvent('Yes')

  const { data } = await useApi(
    `${import.meta.env.VITE_SH_URL}/api/spots/5/webapp/logout`,
  ).post()

  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.logOutHandler
  ) {
    window.webkit.messageHandlers.logOutHandler.postMessage('SHLogoutEvent')
  } else {
    window.postMessage('SHLogoutEvent')
  }
}

const handleCancelLogOut = () => {
  sendLoggedOutEvent('No')
  showLogOutConfirmation.value = false
}
</script>
<template>
  <div
    class="flex w-full items-center gap-1"
    @click="showLogOutConfirmation = true"
  >
    <slot />
  </div>
  <AppDialog
    :is-open="showLogOutConfirmation"
    :can-close="true"
    :has-close-button="false"
    @close="handleCancelLogOut"
  >
    <template #title>
      <div class="text-center">
        <p class="text-sm font-semibold text-brand-black">
          Are you sure you want to Log Out?
        </p>
      </div>
    </template>
    <template #content>
      <div class="text-brand-brand-black px-4 pb-4 text-center">
        <div class="flex gap-4">
          <AppButton
            class="mt-4 !ring-0"
            variant="neutral"
            size="md"
            :is-rounded="true"
            :is-wide="true"
            @click="handleCancelLogOut"
          >
            No
          </AppButton>
          <AppButton
            tabindex="-1"
            class="mt-4 !ring-0 focus:!ring-0"
            size="md"
            variant="success_yes"
            :is-rounded="true"
            :is-wide="true"
            @click="handleLogOut"
          >
            Yes
          </AppButton>
        </div>
      </div>
    </template>
  </AppDialog>
</template>
